import { useDialog } from '@/hooks/useDialog';
import { useRouter } from '@/hooks/useRouter';
import vueRouter from '@/router';
import { useSchool } from '@/shared/hooks/useSchool';
import { useTitle } from '@/shared/hooks/useTitle';
import { queryToString } from '@/utils/query';
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
} from '@vue/composition-api';
import RichTextEditor from '../../common/rich-text-editor.component.vue';
import { Dialog, Typography } from '../../parts';

export default defineComponent({
  components: { RichTextEditor, Typography, Dialog },
  setup() {
    const router = useRouter();
    const { setTitle } = useTitle();
    const { toPrivate } = useSchool();

    const { state: dialogState, openDialog, closeDialog } = useDialog();

    const organizationId = queryToString(router.currentRoute.params.id);
    const name = [router.currentRoute.query.name].flat();

    const state = reactive({ text: '' });

    onMounted(() => {
      setTitle({ title: '強制非公開', icon: 'mdi-square-edit-outline' });
    });

    const handleChange = (text: string) => {
      state.text = text;
    };

    const cancel = () => {
      vueRouter.back();
    };

    const register = async () => {
      if (!organizationId) return;

      return toPrivate({
        organization_ids: organizationId,
        forced_disabled_text: state.text,
      });
    };

    const disabled = computed(() => state.text.length === 0);

    const back = () => {
      vueRouter.back();
    };

    return {
      state,
      cancel,
      register,
      name,
      disabled,
      handleChange,
      dialogState,
      openDialog,
      closeDialog,
      back,
    };
  },
});
